{
    "Accessibility Menu": "Menu di accessibilità",
    "Reset settings": "Ripristina impostazioni",
    "Close": "Chiudi",
    "Content Adjustments": "Regolazioni del contenuto",
    "Adjust Font Size": "Regola la dimensione del carattere",
    "Highlight Title": "Evidenzia il titolo",
    "Highlight Links": "Evidenzia i collegamenti",
    "Readable Font": "Carattere leggibile",
    "Color Adjustments": "Regolazioni del colore",
    "Dark Contrast": "Contrasto scuro",
    "Light Contrast": "Contrasto chiaro",
    "High Contrast": "Alto contrasto",
    "High Saturation": "Alta saturazione",
    "Low Saturation": "Bassa saturazione",
    "Monochrome": "Monocromatico",
    "Protanopia": "Protanopia",
    "Deuteranopia": "Deuteranopia",
    "Tritanopia": "Tritanopia",
    "Visual & Navigation Aids": "Ausili visivi e di navigazione",
    "Additional Tools": "Strumenti aggiuntivi",
    "Reading Guide": "Guida alla lettura",
    "Stop Animations": "Arresta le animazioni",
    "Big Cursor": "Cursore grande",
    "Screen Reader": "Lettore di schermo",
    "Hide Images": "Nascondi immagini",
    "Image Tooltips": "Suggerimenti immagini",
    "Page Structure": "Struttura della pagina",
    "Super Focus": "Super Focus",
    "Magnifier": "Ingranditore",
    "Increase Font Size": "Aumenta la dimensione del carattere",
    "Decrease Font Size": "Diminuisci la dimensione del carattere",
    "Letter Spacing": "Spaziatura delle lettere",
    "Line Height": "Altezza della linea",
    "Font Weight": "Peso del carattere",
    "Dyslexia Font": "Carattere per dislessia",
    "Language": "Lingua",
    "Open Accessibility Menu": "Apri il menu di accessibilità",
    "Accessibility Profiles": "Profili di accessibilità",
    "Seizure Safe Profile": "Profilo sicuro per crisi epilettiche",
    "Stops animations and reduces color saturation.": "Ferma le animazioni e riduce la saturazione dei colori.",
    "Blind Profile": "Profilo per non vedenti",
    "Activates the screen reader for auditory navigation.": "Attiva il lettore di schermo per la navigazione uditiva.",
    "Visually Impaired Profile": "Profilo per ipovedenti",
    "Enhances contrast and readability for low vision.": "Migliora il contrasto e la leggibilità per bassa visione.",
    "ADHD Friendly Profile": "Profilo per ADHD",
    "Reduces distractions for better focus.": "Riduce le distrazioni per una migliore concentrazione.",
    "Cognitive & Learning Profile": "Profilo cognitivo e di apprendimento",
    "Helpful tools for reading and comprehension.": "Strumenti utili per la lettura e la comprensione.",
    "Motor Impaired Profile": "Profilo per disabilità motorie",
    "Optimizes the site for keyboard-only navigation.": "Ottimizza il sito per la navigazione solo da tastiera.",
    "Headings": "Intestazioni",
    "Landmarks": "Punti di riferimento",
    "Links": "Link",
    "Focus element": "Focalizza elemento",
    "Visit link": "Visita link"
}